module.exports = __webpack_public_path__ + "static/media/long-line.0dba2cc7.png";